<template>
  <nk-page commercialAccess="Salary" policyClaims="Salary_SalaryItem_Management">
    <div class="h-100 nk-card">
      <ag-grid :options="componentOptions.tableOptions" :data="tableData"></ag-grid>
    </div>
  </nk-page>
</template>
<script lang="ts">
  import { defineComponent } from 'vue'
  import { post } from '@/plugins/nikan-api'
  import Endpoints from '@nikan/endpoints'
  import Merge from 'lodash/merge'
  import { IResponseList } from '@/interfaces/base'
  import { GridOptions } from 'ag-grid-community'

  interface IUsedContract {
    personnelCode: string
    personnelFirstName: string
    personnelLastName: string
    salaryPeriod: string
    workshop: string
    contractNumber: number
  }

  export default defineComponent({
    name: 'salary-item-contracts-usage',
    modal: {
      size: 'lg',
      stateUID: 'salary-item-contracts-usage'
    },
    props: {
      options: Object
    },
    data() {
      return {
        tableData: [] as IUsedContract[],
        settings: {
          salaryItemId: '',
          isCurrentPeriod: true
        },
        componentOptions: {
          tableOptions: {
            id: this.$options.name,
            pagination: false,
            cellSelectionAggReport: false,
            groupIncludeTotalFooter: true,
            enterToSelect: true,
            suppressRowHoverHighlight: false,
            rowSelection: {
              mode: 'singleRow',
              enableClickSelection: false
            },
            sideBar: 'none',
            columnDefs: [
              {
                field: 'rowNumber',
                headerName: this.$t('row-number'),
                width: 80,
                maxWidth: 120,
                aggFunc: 'count',
              },
              {
                field: 'personnelCode',
                headerName: this.$t('salary.personnel.f.code'),
                contentType: 'string',
                filter: true
              },
              {
                field: 'personnelFirstName',
                headerName: this.$t('salary.personnel.f.firstName'),
                contentType: 'string',
                filter: true
              },
              {
                field: 'personnelLastName',
                headerName: this.$t('salary.personnel.f.lastName'),
                contentType: 'string',
                filter: true
              },
              {
                field: 'salaryPeriod',
                headerName: this.$t('salary.personnel.f.salaryPeriod'),
                contentType: 'string',
                filter: true
              },
              {
                field: 'workshop',
                headerName: this.$t('salary.personnel.f.workshop'),
                contentType: 'string',
                filter: true
              },
              {
                field: 'contractNumber',
                headerName: this.$t('salary.contract.f.number'),
                contentType: 'string',
                filter: true
              },
            ]
          } as GridOptions
        }
      }
    },
    created() {
      this.settings = Merge(this.settings, this.options)
    },
    mounted() {
      this.prepareWindow(this.$t('salary.salary-item.contract-usage'))
      this.getData()
    },
    methods: {
      getData() {
        const wait = this.$wait(this.$el)
        post(Endpoints.getUrl('salaryItem.getUsedContract'), { salaryItemId: this.settings.salaryItemId, isCurrentPeriod: this.settings.isCurrentPeriod }).then((res: IResponseList<IUsedContract>) => {
          this.tableData = res.data.items
        }).catch(() => {

        }).finally(() => {
          wait.end()
        })
      }
    }
  })

</script>
<style></style>